export default {
  props: {
    showLabel: {
      type: Boolean,
      default: true,
      required: false
    },
    model: {
      type: Object,
      // aby móc używać bez podawania modelu
      default: () => ({
        $schema: {
          title: ''
        }
      }),
      required: false
    },
    boldLabel: {
      type: Boolean,
      default: false,
      required: false
    },
    labelFor: {
      type: String,
      default: undefined,
      required: false
    },
    title: {
      type: String,
      default: undefined,
      required: false
    },
    description: {
      type: Object,
      default: () => ({
        value: undefined,
        tooltip: false,
        htmlContent: false,
        newLine: true
      }),
      required: false
    },
    nextNumber: {
      type: Object,
      default: null,
      required: false
    },
    aria: {
      type: String,
      default: ''
    },
    onlyDescription: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isTitle: {
      get() {
        return !!this.getTitle;
      }
    },
    getTitle: {
      get() {
        if ((this.$slots.title && this.$slots.title[0].text.length)) {
          return this.$slots.title[0].text;
        }
        else if (this.title === undefined || this.title === null) {
          return this.model.$schema.title;
        }
        return this.title;
      }
    },
    isDescription: {
      get() {
        return !!this.getDescription;
      }
    },
    getDescription: {
      get() {
        if ((this.$slots.description && this.$slots.description[0].text.length)) {
          return this.$slots.description[0].text;
        }
        else if (this.model && this.model.$schema && this.description.value === undefined) {
          return this.model.$schema.description;
        }
        return this.description.value;
      }
    },
    activeAria() {
      if (!this.showLabel) return this.aria;
      return undefined;
    }
  }
};
